<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';

const props = defineProps({
  modelValue: { type: String, required: true },
});
const emit = defineEmits(['update:modelValue']);

const { t } = useI18n();

const OPTIONS = computed(() => [
  { key: '24h', name: t('REPORT_DASHBOARD.TIME_RANGE.DAY') },
  { key: '7d', name: t('REPORT_DASHBOARD.TIME_RANGE.WEEK') },
  { key: '30d', name: t('REPORT_DASHBOARD.TIME_RANGE.MONTH') },
]);

const selectedIndex = computed(() =>
  OPTIONS.value.findIndex(option => option.key === props.modelValue)
);

const onChange = index => {
  emit('update:modelValue', OPTIONS.value[index].key);
};
</script>

<template>
  <div class="flex justify-center">
    <woot-tabs
      :index="selectedIndex"
      :border="false"
      class="w-fit"
      @change="onChange"
    >
      <woot-tabs-item
        v-for="(option, index) in OPTIONS"
        :key="option.key"
        :index="index"
        :name="option.name"
        :show-badge="false"
        is-compact
      />
    </woot-tabs>
  </div>
</template>
